import React from 'react';
import { Circles } from './components/common/loadingComponent';

import IcapB2BLogo from './img/icapb2b_large.png';

import './appLoadingScreen.scss';
import './root.scss'
import './components/common/loadingComponent.scss'

export const AppLoadingScreen = () => {
    return (
        <div className='app-loading-screen blue-background'>
            <img alt="" className='cribis-logo' src={IcapB2BLogo}></img>
            <Circles useLoginColor />
        </div>
    )
};